export class GridEvent {
    public data: any;
    public type: string;

    constructor(data: any, type: string) {
        this.data = data;
        this.type = type;
    }
}
